import React from "react";
import {Chip} from "@mui/material";
import EmojiEmotionsTwoToneIcon from '@mui/icons-material/EmojiEmotionsTwoTone';
import ThumbDownTwoToneIcon from '@mui/icons-material/ThumbDownTwoTone';
import {deepPurple, green, orange, red} from "@mui/material/colors";

export function getEmptyRows(rowsPerPage, length, page) {
	return rowsPerPage - Math.min(rowsPerPage, length - page * rowsPerPage);
}

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] <
		a[orderBy]
	) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

export function getComparator(order, orderBy) {
	return order === "desc"
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
	if (array.length === 0) {
		return array;
	}
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

export const handleRequestSort = (event, property, order, orderBy, setOrder, setOrderBy, dispatch) => {
	const isAsc = orderBy === property && order === "asc";
	setOrder(isAsc ? "desc" : "asc", dispatch);
	setOrderBy(property, dispatch);
};

export function getDataLabel(data) {
	let seconds = Math.floor((new Date() - new Date(data)) / 1000);
	
	let interval = seconds / 31536000;
	
	if (interval > 1) {
		return Math.floor(interval) + " anni fa";
	}
	interval = seconds / 2592000;
	if (interval > 1) {
		return Math.floor(interval) + " mesi fa";
	}
	interval = seconds / 86400;
	if (interval > 1) {
		return Math.floor(interval) + " giorni fa";
	}
	interval = seconds / 3600;
	if (interval > 1) {
		return Math.floor(interval) + " ore fa";
	}
	interval = seconds / 60;
	if (interval > 1) {
		return Math.floor(interval) + " minuti fa";
	}
	return Math.floor(seconds) + " secondi fa";
}

export function getOnlineIcon(active) {
	if (!active) return <ThumbDownTwoToneIcon/>
	return <EmojiEmotionsTwoToneIcon/>
}

export function getPriorityAvatar(priority, classes) {
	switch (priority) {
		case "Urgente":
		case "urgente":
			return (
				<Chip
					variant={"outlined"}
					className={classes.deepPurple}
					label="Urgente"
					style={{
						color: "#FFF",
						backgroundColor: deepPurple[500],
						padding: "14px 10px 14px 10px",
						width: 100
					}}
				/>
			);
		case "Alta":
		case "alta":
			return (
				<Chip
					variant={"outlined"}
					className={classes.red}
					label="Alta"
					style={{
						color: "#FFF",
						backgroundColor: red[500],
						padding: "14px 10px 14px 10px",
						width: 100
					}}
				/>
			);
		case "Media":
		case "media":
			return (
				<Chip
					variant={"outlined"}
					className={classes.orange}
					label="Media"
					style={{
						color: "#FFF",
						backgroundColor: orange[500],
						padding: "14px 10px 14px 10px",
						width: 100
					}}
				/>
			);
		default:
			return (
				<Chip
					variant={"outlined"}
					className={classes.green}
					label="Bassa"
					style={{
						color: "#FFF",
						backgroundColor: green[500],
						padding: "14px 10px 14px 10px",
						width: 100
					}}
				/>
			);
	}
}
